import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import history from '../utils/history';
import { checkIfHotjarEnable, timeBetweenDates } from '../utils/helpers';
import * as sinisterCardsActions from '../redux/actions/sinister-cards';
import FilesUploadingProps from '../data/filesUploadingProps_old';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import Navbar from '../components/common/Navbar/Navbar';
import FileAttachComp from '../components/content/FileAttachComp/FileAttachComp';
import InfoCard from '../components/content/InfoCard/InfoCard';
import IconInfo from '../assets/infoIcon.svg';

const FilesAttachPage = () => {
  const dispatch = useDispatch();
  const { listFiles } = FilesUploadingProps;
  const sinisterFileList = useSelector(
    (state) => state.sinisterCards.sinisterFiles
  );
  const sinisterList = useSelector((state) => state.sinisterCards.sinisterList);
  const foundCob5 = sinisterList.filter((item) => item.code === 'COB05');
  const foundCob6 = sinisterList.filter((item) => item.code === 'COB06');
  const foundNom0 = sinisterList.filter((item) => item.code === 'COB01' && item.sinisterNum === '1');

  const mapedFiles = listFiles.filter(
    (file) => file.id !== '5' && file.id !== '6' && file.id !== '7'
  );
  const [viewStartTime, setViewStartTime] = useState(new Date());

  if (foundCob5.length > 0) mapedFiles.push(listFiles[4]);
  if (foundCob6.length > 0) mapedFiles.push(listFiles[5]);
  if (foundNom0.length > 0) mapedFiles.push(listFiles[6]);


  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    return () => {
      const endTime = new Date();
      const userTotalTime = timeBetweenDates(viewStartTime, endTime);

      if (checkIfHotjarEnable()) {
        window.digitalData.push({
          task: {
            name: 'Tiempo registrado - Documentos requeridos',
            time: userTotalTime,
          },
          event: 'trackTimeToComplete',
        });
      }
    };
  }, []);

  const isNextActive = () => {
    if (foundCob5.length > 0 && foundCob6.length > 0 && foundNom0.length > 0) {
      if (sinisterFileList.length < 7) {
        return true;
      }
    }
    if (foundCob5.length > 0 && foundCob6.length === 0 && foundNom0.length === 0) {
      if (sinisterFileList.length < 5) {
        return true;
      }
    }
    if (foundCob6.length > 0 && foundCob5.length > 0 && foundNom0.length === 0) {
      if (sinisterFileList.length < 6) {
        return true;
      }
    }
    if (foundNom0.length > 0 && foundCob5.length > 0 && foundCob6.length === 0) {
      if (sinisterFileList.length < 6) {
        return true;
      }
    }
    if (foundNom0.length === 0 && foundCob5.length === 0 && foundCob6.length > 0) {
      if (sinisterFileList.length < 5) {
        return true;
      }
    }
    if (foundNom0.length > 0 && foundCob5.length === 0 && foundCob6.length > 0) {
      if (sinisterFileList.length < 6) {
        return true;
      }
    }
    if (foundNom0.length > 0 && foundCob5.length === 0 && foundCob6.length === 0) {
      if (sinisterFileList.length < 5) {
        return true;
      }
    }
    if (foundNom0.length === 0 && foundCob5.length === 0 && foundCob6.length === 0) {
      if (sinisterFileList.length < 4) {
        return true;
      }
    }
    
    for (const item of sinisterFileList) {
      if (item.files <= 0) {
        return true;
      }
    }

    return false;
  };

  const onBackHandler = () => {
    dispatch(sinisterCardsActions.reduceStep());
    history.replace('/antes-de-comenzar');
  };

  const onContinueHandler = () => {
    dispatch(sinisterCardsActions.incrementStep());
    history.replace('/montos-robados');
  };

  return (
    <>
      <RimacTopBar />
      <div
        data-testid="files-attach-page"
        className="filesAttachPage pageContainer"
      >
        <div className="filesAttachPage__left pageContainer__left">
          <div className="titleCont">
            <h1 className="u-mb-24">Seguro de Protección de Tarjetas</h1>
            <p>
              Hola, sabemos que sufriste un siniestro y queremos ayudarte a
              reportarlo.
            </p>
          </div>
        </div>

        <div className="filesAttachPage__right pageContainer__right">
          <div className="titleCont">
            <h2 className="u-mb-16">Adjunta los siguientes documentos</h2>

            <InfoCard
              icon={IconInfo}
              customClasses={'u-mb-40'}
              content={
                <p>
                  <b>Recuerda:</b> Si tienes dudas sobre algún documento, puedes
                  ver los ejemplos.
                </p>
              }
            />

            <div className="mainContent">
              {mapedFiles &&
                mapedFiles.map((resp, i) => {
                  return (
                    <div
                      data-testid={'attach-input-' + i}
                      key={'up-file-' + i}
                      className="u-mb-40-32"
                    >
                      <FileAttachComp
                        title={resp.title}
                        customClass={
                          i < mapedFiles.length - 1 ? 'borderBotResp' : ''
                        }
                        description={resp.description}
                        docUrl={resp.docUrl}
                        typeFile={resp.typeFile}
                        typeFileId={resp.id}
                        currentFiles={sinisterFileList.find(
                          (item) => item.id === resp.id
                        )}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        <Navbar
          navActive
          isNextDisabled={isNextActive()}
          onContinueClick={onContinueHandler}
          onBackClick={onBackHandler}
          currentStep={2}
          totalSteps={5}
        />

        <div className="spacingLeft"></div>
      </div>
    </>
  );
};

export default FilesAttachPage;
